export const formatCurrency = (n) => {
  const v = parseFloat(n) || 0;
  return '₹ ' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const today = () => new Date().toISOString().split('T')[0];

export const monthStart = () => {
  const d = new Date(); d.setDate(1);
  return d.toISOString().split('T')[0];
};

export const daysBetween = (d1, d2) => {
  const ms = new Date(d2) - new Date(d1);
  return Math.round(ms / (1000 * 60 * 60 * 24));
};
